/**
 * Comportamentos próprios do tema Profizic.
 *
 * Carregado a partir do theme.liquid e não de um bloco: neste tema o
 * `{% javascript %}` dentro de blocos não chega a correr.
 */

/**
 * Slideshow com imagem separada para desktop e telemóvel.
 *
 * Cada slideshow gere-se sozinho, por isso a inicialização corre por elemento
 * e não uma vez global: o editor de temas substitui secções sem recarregar a
 * página, e cada nova instância precisa do seu próprio temporizador.
 */
function initProfizicSlideshow(root) {
  if (root.dataset.slideshowReady === 'true') return;
  root.dataset.slideshowReady = 'true';

  const slides = [...root.querySelectorAll('.profizic-slideshow__slide')];
  const dots = [...root.querySelectorAll('.profizic-slideshow__dot')];
  if (slides.length < 2) return;

  let current = 0;
  let timer = null;

  const calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  const small = window.matchMedia('(max-width: 749px)');

  // O video de um slide, se ele tiver. Nem todos tem.
  const videoDe = (slide) => slide.querySelector('[data-pz-slide-video]');

  // Se se deve tocar video, agora, neste ecra. Tres nos possiveis, e cada um
  // deles significa "fica so a imagem".
  const podeVideo = () => {
    if (calm.matches) return false;
    if (small.matches && root.dataset.mostrarVideoMobile !== 'true') return false;
    return true;
  };

  // A fonte e ligada aqui e nao no HTML: e o que garante que um telemovel com
  // a opcao desligada nao descarrega um unico byte de video.
  const ligarFonte = (video) => {
    const url = small.matches ? video.dataset.videoMobile : video.dataset.videoDesktop;
    if (!url) return;

    // Comparado com o que ja esta ligado, e nao com "ja liguei alguma coisa":
    // o video de telemovel pode ser outro ficheiro, com outro enquadramento, e
    // ao rodar o telefone tem de trocar. A versao anterior guardava so um
    // "ja liguei" e ficava presa ao ficheiro do primeiro ecra.
    if (video.dataset.fonteAtual === url) return;

    video.src = url;
    video.dataset.fonteAtual = url;
  };

  const pararVideos = () => {
    slides.forEach((slide) => {
      const video = videoDe(slide);
      if (!video) return;
      video.pause();
      video.removeAttribute('data-pz-visivel');
    });
  };

  const tocarVideoDoSlide = (slide) => {
    const video = videoDe(slide);
    if (!video || !podeVideo()) return;

    ligarFonte(video);

    // Sem repeticao quando o slide espera pelo fim: o `ended` e que manda
    // passar, e um video em `loop` nunca termina.
    video.loop = root.dataset.esperarVideo !== 'true';
    video.currentTime = 0;

    video
      .play()
      .then(() => video.setAttribute('data-pz-visivel', ''))
      // Um `play()` recusado nao e um erro: o browser pode decidir que nao e
      // altura (bateria, separador em fundo). Fica a imagem, que e o cartaz.
      .catch(() => {});
  };

  const show = (index) => {
    current = (index + slides.length) % slides.length;
    slides.forEach((s, i) => s.classList.toggle('is-active', i === current));
    dots.forEach((d, i) => {
      d.classList.toggle('is-active', i === current);
      d.setAttribute('aria-selected', i === current ? 'true' : 'false');
    });

    pararVideos();
    tocarVideoDoSlide(slides[current]);
  };

  const start = () => {
    if (root.dataset.autoplay !== 'true') return;
    // Movimento automático pode causar desconforto; quem pediu movimento
    // reduzido fica com o slideshow parado, navegável pelos pontos.
    if (calm.matches) return;
    stop();

    // Um slide com vídeo a tocar e com "esperar que acabe" ligado não leva
    // temporizador: quem manda passar é o `ended` do vídeo. Com o
    // temporizador a correr por cima, um vídeo de 12 segundos era cortado aos
    // 6 e a opção não servia para nada.
    const video = videoDe(slides[current]);
    if (video && root.dataset.esperarVideo === 'true' && podeVideo() && !video.paused) return;

    timer = setInterval(() => show(current + 1), Number(root.dataset.speed) || 6000);
  };

  const stop = () => {
    if (timer) clearInterval(timer);
    timer = null;
  };

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      show(Number(dot.dataset.goto));
      start();
    });
  });

  // Parar enquanto o rato está em cima ou o teclado tem foco dentro: dá tempo
  // de ler e de clicar sem o slide mudar por baixo.
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', start);

  slides.forEach((slide) => {
    const video = videoDe(slide);
    if (!video) return;

    video.addEventListener('ended', () => {
      if (root.dataset.autoplay !== 'true') return;
      if (root.dataset.esperarVideo !== 'true') return;
      show(current + 1);
      start();
    });

    // Um vídeo que não consiga tocar deixa de contar: sem isto, o slide ficava
    // à espera de um `ended` que nunca vinha e o slideshow parava ali.
    video.addEventListener('error', () => {
      video.removeAttribute('data-pz-visivel');
      start();
    });
  });

  // Rodar o telefone, ou mudar a preferência de movimento no sistema, muda a
  // resposta do `podeVideo()`.
  const reavaliar = () => {
    pararVideos();
    tocarVideoDoSlide(slides[current]);
    start();
  };
  small.addEventListener('change', reavaliar);
  calm.addEventListener('change', reavaliar);

  show(0);
  start();
}

function setupProfizicSlideshows() {
  document.querySelectorAll('.profizic-slideshow').forEach(initProfizicSlideshow);
}

document.addEventListener('DOMContentLoaded', setupProfizicSlideshows);
// O editor de temas troca secções sem recarregar a página.
document.addEventListener('shopify:section:load', setupProfizicSlideshows);

/**
 * Botão "Copiar ligação" na partilha de artigos.
 *
 * Delegação no documento em vez de um listener por botão, porque as secções
 * do editor de temas são substituídas sem recarregar a página, e os listeners
 * ligados diretamente perder-se-iam.
 */
document.addEventListener('click', async (event) => {
  const button = event.target.closest('.profizic-share__btn--copy');
  if (!button) return;

  const url = button.dataset.shareUrl;
  if (!url) return;

  const label = button.querySelector('span');
  const original = label ? label.textContent : '';

  try {
    // navigator.clipboard só existe em contextos seguros (HTTPS ou localhost).
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url);
    } else {
      // Alternativa para HTTP: campo temporário fora do ecrã.
      const field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'absolute';
      field.style.left = '-9999px';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      document.body.removeChild(field);
    }

    // Mensagens vindas do editor de temas, para poderem ser traduzidas ou
    // encurtadas sem mexer neste ficheiro.
    if (label) label.textContent = button.dataset.copiedText || 'Ligação copiada';
    button.classList.add('profizic-share__btn--copied');

    setTimeout(() => {
      if (label) label.textContent = original;
      button.classList.remove('profizic-share__btn--copied');
    }, 2000);
  } catch (error) {
    // Se a cópia falhar, mostrar o endereço para o visitante o copiar à mão
    // é melhor do que não dar sinal nenhum.
    if (label) label.textContent = button.dataset.errorText || 'Não foi possível copiar';
    setTimeout(() => {
      if (label) label.textContent = original;
    }, 2000);
  }
});

/**
 * Tabelas nutricionais coladas na admin.
 *
 * O HTML da tabela é escrito no campo "Tabela nutricional" de cada produto,
 * por isso chega sem classes e sem rótulos repetidos nas células. Numa coluna
 * de produto estreita quatro colunas de números não cabem, e a tabela passa a
 * ficha empilhada (regras `@container` em profizic.css).
 *
 * Empilhada, cada valor precisa de dizer a que coluna pertencia, senão ficam
 * números soltos sem significado. Esta função copia os cabeçalhos da primeira
 * linha para um atributo `data-col` em cada célula, que o CSS imprime à frente
 * do valor.
 *
 * A marca `data-stacked` só é posta quando há cabeçalhos para copiar: sem eles
 * a tabela fica como grelha normal, que continua legível, em vez de empilhar
 * sem rótulos.
 */
function setupProfizicNutritionTables() {
  document.querySelectorAll('.profizic-nutrition-wrap--rich table').forEach((table) => {
    if (table.dataset.stacked) return;

    const rows = table.rows;
    if (rows.length < 2) return;

    // Os cabeçalhos podem vir em <th> ou em <td>: o editor da admin nem sempre
    // marca a diferença, e uma tabela colada do Excel costuma trazer <td>.
    const headers = [...rows[0].cells].map((cell) => cell.textContent.trim());
    if (headers.length < 2 || headers.every((text) => text === '')) return;

    // A primeira linha é o cabeçalho, mesmo quando não está dentro de <thead>.
    // Sem isto, empilhada, apareceria como se fosse mais um nutriente.
    if (!table.tHead && rows[0].parentElement) {
      const head = table.createTHead();
      head.appendChild(rows[0]);
    }

    [...table.tBodies].forEach((body) => {
      [...body.rows].forEach((row) => {
        [...row.cells].forEach((cell, index) => {
          // A primeira coluna é o nome do nutriente e já se explica sozinha.
          if (index === 0) return;
          const label = headers[index];
          if (label) cell.setAttribute('data-col', label);
        });
      });
    });

    table.dataset.stacked = 'true';
  });
}

document.addEventListener('DOMContentLoaded', setupProfizicNutritionTables);
// O editor de temas troca blocos sem recarregar a página.
document.addEventListener('shopify:section:load', setupProfizicNutritionTables);
document.addEventListener('shopify:block:select', setupProfizicNutritionTables);

/**
 * Realce da tabela do sabor escolhido.
 *
 * As tabelas de todos os sabores estão à vista, para se poderem comparar. Esta
 * função só marca qual delas é a do sabor que está escolhido, para quem já
 * decidiu não ter de procurar o nome na lista.
 *
 * A marca é mudada aqui e não pelo tema porque, ao mudar de sabor na página de
 * produto, o Savor só volta a desenhar o seletor de variantes. O resto da
 * coluna é atualizado por quem estiver a ouvir `shopify:product:select`, que é
 * o que esta função faz.
 *
 * O identificador da variante vem no próprio evento, sem esperar pela rede, e
 * pode chegar como número ou como `gid://shopify/ProductVariant/123`. Só os
 * dígitos interessam.
 */
function setupProfizicNutritionVariants() {
  document.querySelectorAll('[data-nutrition-variants]').forEach((root) => {
    if (root.dataset.variantsReady === 'true') return;
    root.dataset.variantsReady = 'true';

    const section = root.closest('.shopify-section') || document;
    const panels = [...root.querySelectorAll('[data-nutrition-variant]')];
    // A tabela comum, quando existe. Serve os sabores que nao tem tabela
    // propria: no modo "so a escolhida", sem isto o visitante escolhia um
    // sabor sem tabela e ficava com o acordeao vazio.
    const fallback = root.querySelector('[data-nutrition-fallback]');

    const highlight = (variantId, flavour) => {
      // O identificador é o sinal principal. O nome do sabor é a rede de
      // segurança: numa combinação sem variante, ou se o tema deixar de
      // mandar o identificador no evento, a tabela certa ainda é encontrada.
      const match =
        panels.find((panel) => variantId && panel.dataset.nutritionVariant === variantId) ||
        panels.find((panel) => flavour && panel.dataset.nutritionFlavour === flavour);

      panels.forEach((panel) => {
        const on = panel === match;
        panel.classList.toggle('is-selected', on);
        panel.toggleAttribute('data-nutrition-selected', on);
      });

      if (fallback) {
        const on = !match;
        fallback.classList.toggle('is-selected', on);
        fallback.toggleAttribute('data-nutrition-selected', on);
      }
    };

    section.addEventListener('shopify:product:select', (event) => {
      if (event.target instanceof Element && event.target.closest('product-card')) return;

      const raw = event.detail?.variantId;
      const variantId = raw ? String(raw).split('/').pop() : '';
      const flavour = event.selectedOptions?.map((option) => option.value).join(' / ');
      highlight(variantId, flavour);
    });
  });
}

document.addEventListener('DOMContentLoaded', setupProfizicNutritionVariants);
document.addEventListener('shopify:section:load', setupProfizicNutritionVariants);

/* ---------------------------------------------------------------------------
   Introducao das categorias: dobra em ecrans pequenos
   ---------------------------------------------------
   Um texto de categoria com dois ou tres paragrafos empurra a grelha de
   produtos para fora do ecra num telemovel. Abaixo dos 749px o texto fica
   dobrado a cinco linhas com um botao para abrir; em computador aparece
   sempre inteiro.

   A dobra e posta aqui e nao no CSS porque so se sabe se o texto passa das
   cinco linhas depois de ele estar desenhado. Sem JavaScript nao ha dobra
   nenhuma e o texto aparece todo, que e o comportamento certo por omissao.
--------------------------------------------------------------------------- */

const PROFIZIC_INTRO_LINHAS = 5;
const profizicIntroEcraEstreito = window.matchMedia('(max-width: 749px)');

function profizicIntroEtiqueta(botao, corpo) {
  const aberto = !corpo.hasAttribute('data-dobrado');
  botao.textContent = aberto
    ? corpo.dataset.menos || 'Ler menos'
    : corpo.dataset.mais || 'Ler mais';
  botao.setAttribute('aria-expanded', String(aberto));
}

function profizicIntroDobra(corpo) {
  const caixa = corpo.parentElement;
  if (!caixa) return;

  let botao = caixa.querySelector('.profizic-intro__toggle');

  if (!profizicIntroEcraEstreito.matches) {
    corpo.removeAttribute('data-dobrado');
    if (botao) botao.remove();
    return;
  }

  // Medir com o texto aberto: dobrado, `scrollHeight` daria a altura cortada.
  corpo.removeAttribute('data-dobrado');
  const linha = parseFloat(window.getComputedStyle(corpo).lineHeight) || 24;
  const cabe = corpo.scrollHeight <= linha * (PROFIZIC_INTRO_LINHAS + 0.5);

  if (cabe) {
    if (botao) botao.remove();
    return;
  }

  corpo.setAttribute('data-dobrado', '');

  if (!botao) {
    botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'profizic-intro__toggle';
    if (corpo.id) botao.setAttribute('aria-controls', corpo.id);
    botao.addEventListener('click', () => {
      if (corpo.hasAttribute('data-dobrado')) {
        corpo.removeAttribute('data-dobrado');
      } else {
        corpo.setAttribute('data-dobrado', '');
      }
      profizicIntroEtiqueta(botao, corpo);
    });
    caixa.appendChild(botao);
  }

  profizicIntroEtiqueta(botao, corpo);
}

function setupProfizicCollectionIntro() {
  document.querySelectorAll('[data-profizic-intro]').forEach(profizicIntroDobra);
}

document.addEventListener('DOMContentLoaded', setupProfizicCollectionIntro);
document.addEventListener('shopify:section:load', setupProfizicCollectionIntro);
profizicIntroEcraEstreito.addEventListener('change', setupProfizicCollectionIntro);

/* ---------------------------------------------------------------------------
   Barra de garantias: rotativo no telemovel
   -----------------------------------------
   O deslize e nativo (`scroll-snap` no CSS), por isso funciona sem isto. Esta
   funcao so acrescenta duas coisas: rodar sozinho e acender o ponto certo.

   Empurra o `scrollLeft` em vez de trocar classes de visibilidade: assim o
   dedo e o automatico usam o mesmo mecanismo e nunca se contradizem. E le a
   posicao de volta do `scroll`, para o ponto aceso ser sempre o que se ve,
   mesmo quando foi o dedo a mandar.
   --------------------------------------------------------------------------- */

function initProfizicTrust(root) {
  if (root.dataset.trustReady === 'true') return;
  root.dataset.trustReady = 'true';

  const list = root.querySelector('.profizic-trust__list');
  const items = [...root.querySelectorAll('.profizic-trust__item')];
  const dots = [...root.querySelectorAll('.profizic-trust__ponto')];
  if (!list || items.length < 2) return;

  // Fora do telemovel os tres estao lado a lado e nao ha nada a rodar. A
  // consulta e feita uma vez e ouvida: rodar o telefone muda a resposta.
  const small = window.matchMedia('(max-width: 749px)');
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)');

  let index = 0;
  let timer = null;

  const paint = () => {
    dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));
  };

  // A posicao e medida com `getBoundingClientRect` e nao com `offsetLeft`.
  // O `offsetLeft` de um item e medido em relacao ao primeiro antepassado
  // posicionado, que aqui nao e a lista, e o `offsetLeft` da propria lista e
  // medido em relacao a outro elemento ainda. Subtrair um do outro dava um
  // numero pequeno, e ir para o item 2 deixava o deslize quase no item 1 —
  // era isso que fazia o primeiro e o segundo parecerem iguais.
  const posicao = (item) =>
    item.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;

  const goTo = (next, smooth = true) => {
    index = (next + items.length) % items.length;
    list.scrollTo({ left: posicao(items[index]), behavior: smooth ? 'smooth' : 'auto' });
    paint();
  };

  const stop = () => {
    if (timer) clearInterval(timer);
    timer = null;
  };

  const start = () => {
    stop();
    if (root.dataset.autoplay !== 'true') return;
    if (!small.matches || calm.matches) return;
    timer = setInterval(() => goTo(index + 1), Number(root.dataset.speed) || 4000);
  };

  // A posicao real manda no ponto aceso. Sem isto, deslizar com o dedo deixava
  // o ponto a apontar para o item errado.
  let settle = null;
  list.addEventListener('scroll', () => {
    clearTimeout(settle);
    settle = setTimeout(() => {
      const middle = list.scrollLeft + list.clientWidth / 2;
      const closest = items.reduce(
        (best, item, i) => {
          const centre = posicao(item) + item.clientWidth / 2;
          const gap = Math.abs(centre - middle);
          return gap < best.gap ? { i, gap } : best;
        },
        { i: index, gap: Infinity }
      );
      index = closest.i;
      paint();
    }, 80);
  });

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      goTo(Number(dot.dataset.goto));
      start();
    });
  });

  // Um dedo em cima e alguem a ler. Nao lhe mudar a frase por baixo.
  list.addEventListener('pointerdown', stop);
  list.addEventListener('pointerup', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', start);

  small.addEventListener('change', start);
  calm.addEventListener('change', start);

  paint();
  start();
}

function setupProfizicTrust() {
  document.querySelectorAll('.profizic-trust').forEach(initProfizicTrust);
}

document.addEventListener('DOMContentLoaded', setupProfizicTrust);
document.addEventListener('shopify:section:load', setupProfizicTrust);

/* ---------------------------------------------------------------------------
   Video no cartao de produto
   --------------------------
   O video esta no HTML com `preload="none"`: nao pesa nada ate ser preciso.
   Esta funcao decide quando o e.

   No computador manda o rato. Num telemovel nao ha rato, e um `:hover` em ecra
   de toque ou nao dispara ou fica preso depois do primeiro toque; ai quem manda
   e o `IntersectionObserver`, que toca o video do cartao que esta a ser visto.

   `play()` devolve uma promessa que o navegador rejeita quando decide que nao
   e altura de tocar (poupanca de bateria, separador em fundo). E um nao, nao um
   erro: apanha-se e ignora-se, senao enche a consola de avisos.
   --------------------------------------------------------------------------- */

function initProfizicCardVideo(video) {
  if (video.dataset.videoReady === 'true') return;
  video.dataset.videoReady = 'true';

  const card = video.closest('product-card') || video.closest('.card-gallery');
  if (!card) return;

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const toca = () => {
    video.play().catch(() => {});
  };

  const para = () => {
    video.pause();
    // Voltar ao inicio: quem passa outra vez pelo cartao ve o video de novo, e
    // nao um fotograma qualquer do meio.
    video.currentTime = 0;
  };

  card.addEventListener('pointerenter', toca);
  card.addEventListener('pointerleave', para);
  card.addEventListener('focusin', toca);
  card.addEventListener('focusout', para);

  // Telemovel. A opcao vive numa definicao do tema e chega por um atributo no
  // `<body>`, porque este ficheiro nao le `settings`.
  const modoMobile = document.body.dataset.pzCardVideoMobile || 'nao';
  if (modoMobile !== 'ao_entrar') return;

  const small = window.matchMedia('(max-width: 749px)');
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!small.matches) return;
        if (entry.isIntersecting) {
          video.setAttribute('data-pz-playing', '');
          toca();
        } else {
          video.removeAttribute('data-pz-playing');
          para();
        }
      });
    },
    // Metade do cartao a vista: mais do que isso e o video toca em cartoes que
    // so assomam na borda do ecra.
    { threshold: 0.5 }
  );
  observer.observe(card);
}

function setupProfizicCardVideos() {
  document.querySelectorAll('[data-pz-card-video]').forEach(initProfizicCardVideo);
}

document.addEventListener('DOMContentLoaded', setupProfizicCardVideos);
document.addEventListener('shopify:section:load', setupProfizicCardVideos);

/* ---------------------------------------------------------------------------
   Pop-up da newsletter
   --------------------
   Abre passado o tempo definido na secção, e nao volta a abrir a quem fechou
   ou subscreveu, durante os dias definidos.

   A memoria e o `localStorage`, com a data de validade guardada dentro. Nao ha
   conta nem servidor: e uma nota no navegador da pessoa. Quem limpar os dados
   do navegador volta a ver o pop-up, e isso e aceitavel — o contrario exigia
   identificar visitantes anonimos.

   Todos os acessos ao `localStorage` vao dentro de `try`: num separador
   privado, ou com os dados do site bloqueados, a simples leitura atira erro, e
   um erro aqui deixava a pagina sem o resto do JavaScript deste ficheiro.
   --------------------------------------------------------------------------- */

function pzLerMarca(chave) {
  try {
    const bruto = localStorage.getItem(chave);
    if (!bruto) return false;
    const ate = Number(bruto);
    if (!ate || Number.isNaN(ate)) return false;
    if (Date.now() > ate) {
      localStorage.removeItem(chave);
      return false;
    }
    return true;
  } catch (erro) {
    return false;
  }
}

function pzEscreverMarca(chave, dias) {
  try {
    localStorage.setItem(chave, String(Date.now() + dias * 24 * 60 * 60 * 1000));
  } catch (erro) {
    // Sem sitio para guardar, o pop-up volta a aparecer na proxima visita. E
    // pior do que o combinado, mas melhor do que rebentar.
  }
}

/* O BANNER DE COOKIES VEM PRIMEIRO.
   Medido no browser: com o pop-up aberto, o clique no botao "Aceitar" do
   banner de consentimento nao chega ao botao — chega ao pop-up. Um `<dialog>`
   modal torna inacessivel tudo o que esta fora dele, e o banner fica preso
   atras. A pessoa nao consegue aceitar os cookies sem primeiro fechar um
   pop-up que ela nao pediu.

   Por isso o pop-up espera pelo banner.

   A primeira versao disto procurava o banner uma vez e falhou: a Shopify
   injecta-o DEPOIS do carregamento da pagina, por isso no arranque ele ainda
   nao existe e a verificacao dava sempre "nao ha banner". Confirmado a
   correr o browser: o pop-up abria por cima dele, exactamente como antes.

   Daqui a espiar em vez de perguntar uma vez. Tres olhares por segundo nao
   custam nada, e a logica fica obvia: enquanto o banner estiver no ecra
   espera-se; se nunca aparecer em tres segundos, e porque nao ha nenhum.

   Se a pessoa nunca responder ao banner, o pop-up nunca aparece. E o certo:
   o consentimento e obrigatorio, o pop-up nao. */
function pzEsperarBannerDeCookies(seguir) {
  const noEcra = () => {
    const banner = document.getElementById('shopify-pc__banner');
    if (!banner || !banner.isConnected) return false;
    if (banner.getBoundingClientRect().height <= 0) return false;
    return getComputedStyle(banner).visibility !== 'hidden';
  };

  const inicio = Date.now();
  // 2 segundos e generoso: a Shopify injecta o banner durante o carregamento,
  // e o tempo escolhido na secao ja passou antes de se chegar aqui. Isto e so
  // uma rede para uma injeccao lenta — mais do que isto atrasava o pop-up sem
  // razao em quem ja deu consentimento.
  const TEMPO_ATE_DESISTIR_DE_O_VER = 2000;
  const TEMPO_MAXIMO_DE_ESPERA = 10 * 60 * 1000;
  let jaApareceu = false;

  const olhar = () => {
    if (noEcra()) {
      jaApareceu = true;
      if (Date.now() - inicio < TEMPO_MAXIMO_DE_ESPERA) setTimeout(olhar, 300);
      return;
    }

    // Ainda nao apareceu. Pode ser uma loja sem banner, ou pode estar a
    // caminho — espera-se um instante por ele antes de seguir.
    if (!jaApareceu && Date.now() - inicio < TEMPO_ATE_DESISTIR_DE_O_VER) {
      setTimeout(olhar, 300);
      return;
    }

    seguir();
  };

  olhar();
}

function initProfizicPopup(popup) {
  if (popup.dataset.popupReady === 'true') return;
  popup.dataset.popupReady = 'true';

  const chave = popup.dataset.key || 'pz-popup';
  const dias = Number(popup.dataset.rememberDays) || 30;
  const atraso = Number(popup.dataset.delay) || 0;

  // CORRIGIDO: no editor de temas NAO se guarda a marca.
  //
  // O editor desenha a loja num iframe no dominio da loja, ou seja o
  // `localStorage` e o mesmo da loja a serio. Fechar o pop-up dentro do editor
  // — ou so clicar noutra secao, que tambem o fecha — escrevia a marca de 30
  // dias, e depois o pop-up nao aparecia na pre-visualizacao. Parecia avariado
  // e nao estava: estava a cumprir uma marca escrita por engano.
  const modoEditor = document.documentElement.classList.contains('shopify-design-mode');
  const marcarVisto = () => {
    if (!modoEditor) pzEscreverMarca(chave, dias);
  };

  const fechar = () => {
    if (popup.open) popup.close();
    marcarVisto();
  };

  popup.querySelectorAll('[data-pz-popup-fechar]').forEach((botao) => {
    botao.addEventListener('click', fechar);
  });

  // Clique fora da caixa. O `<dialog>` recebe o clique no proprio elemento
  // quando se acerta no veu, porque a caixa e um filho: se o alvo for o
  // dialogo, foi no veu.
  popup.addEventListener('click', (evento) => {
    if (evento.target === popup) fechar();
  });

  // A tecla Escape e tratada pelo elemento nativo, mas o `close` que ela
  // dispara nao passa por aqui. Ouvir o evento garante que fechar por Escape
  // conta como fechado.
  popup.addEventListener('close', marcarVisto);

  // Quem acabou de subscrever ve a mensagem de sucesso: abre-se logo, sem
  // esperar, e marca-se como visto.
  //
  // E quem se enganou no email tambem: a mensagem de erro nao pode ficar seis
  // segundos a espera para aparecer, senao a pessoa ja saiu da pagina e nunca
  // soube que o email nao passou.
  const resposta = popup.querySelector('[data-pz-popup-ok], [data-pz-popup-erro]');
  if (resposta) {
    popup.showModal();
    if (popup.querySelector('[data-pz-popup-ok]')) marcarVisto();
    return;
  }

  // No editor de temas nao abre sozinho: um pop-up a abrir a cada recarga
  // tapava as outras secoes e nao a deixava trabalhar. Abre quando ela clica
  // no pop-up na lista da esquerda, e fecha quando clica noutra coisa.
  if (document.documentElement.classList.contains('shopify-design-mode')) {
    const secao = popup.closest('.shopify-section') || popup.parentElement;
    document.addEventListener('shopify:section:select', (evento) => {
      if (evento.target === secao || evento.target?.contains?.(popup)) {
        if (!popup.open) popup.showModal();
      }
    });
    document.addEventListener('shopify:section:deselect', (evento) => {
      if (evento.target === secao || evento.target?.contains?.(popup)) {
        if (popup.open) popup.close();
      }
    });
    return;
  }

  if (pzLerMarca(chave)) return;

  // A ordem importa: primeiro conta-se o tempo escolhido na secao, e so
  // depois se espera pelo banner. Ao contrario, o tempo comecava a contar
  // antes de o banner existir e as duas esperas somavam-se.
  setTimeout(() => {
    pzEsperarBannerDeCookies(() => {
      // Relido: entre o banner e o fim da espera pode ter passado bastante
      // tempo, e a marca pode ter sido escrita noutro separador.
      if (pzLerMarca(chave)) return;
      if (!popup.open) popup.showModal();
    });
  }, atraso);
}

function setupProfizicPopups() {
  document.querySelectorAll('[data-pz-popup]').forEach(initProfizicPopup);
}

document.addEventListener('DOMContentLoaded', setupProfizicPopups);
document.addEventListener('shopify:section:load', setupProfizicPopups);


/* ---------------------------------------------------------------------------
   Widget de bundles: marcar a secao do produto
   -------------------------------------------
   A app Pumper Bundles injeta o widget depois de a pagina estar desenhada, e
   nao ha promessa nenhuma sobre onde. Duas tentativas anteriores falharam por
   dependerem demais dela:

   1. So CSS, com `.product-details:has(.pmpr_bundle__root) > variant-picker`.
      Adivinhava que o widget entra dentro do `product-details` e que o seletor
      de sabor e filho direto dele. Nao e nem uma coisa nem outra.
   2. JavaScript, mas a procurar a classe exata `.pmpr_bundle__root`. Um nome
      completo de classe de uma app e a coisa mais volatil que ha.

   Esta versao procura pelo **prefixo** `pmpr`, que e o que a app usa em tudo o
   que desenha e o que menos muda entre versoes. A lista de sinais e uma
   definicao do tema, para poder ser corrigida no painel sem tocar em codigo.

   Nao ha trave nenhuma neste ficheiro: a marca e sempre posta. Quem decide se
   esconde algo e o CSS, que exige o atributo no `<body>`. Uma condicao a menos
   e um sitio a menos onde isto pode falhar em silencio.
   --------------------------------------------------------------------------- */

const PZ_BUNDLE_SINAIS_RESERVA = '[class*="pmpr"], [id*="pmpr"], [data-pumper], [class*="pumper"]';

function pzMarcarBundles() {
  const sinais = document.body.dataset.pzBundleSinais || PZ_BUNDLE_SINAIS_RESERVA;

  let widgets = [];
  try {
    widgets = [...document.querySelectorAll(sinais)];
  } catch (erro) {
    // Um seletor mal escrito no painel atira `SyntaxError` e levava tudo o que
    // vem a seguir com ele. Cai-se na lista de reserva.
    widgets = [...document.querySelectorAll(PZ_BUNDLE_SINAIS_RESERVA)];
  }

  if (!widgets.length) return false;

  widgets.forEach((widget) => {
    // A secao do produto e o alvo. So conta se essa secao tiver mesmo controlos
    // do tema para esconder: sem esta verificacao, um sinal da app no rodape ou
    // num cartao marcava uma secao onde nao ha nada a fazer.
    const alvo =
      widget.closest('.shopify-section') ||
      widget.closest('product-information') ||
      widget.closest('main');

    if (!alvo) return;
    if (!alvo.querySelector('variant-picker, product-price')) return;

    alvo.setAttribute('data-pz-bundle', '');
  });

  return true;
}

function setupProfizicBundles() {
  pzMarcarBundles();

  // Nao se desliga na primeira vez que encontra: a app volta a desenhar o
  // widget quando se muda de nivel, e o tema volta a desenhar a coluna de
  // informacao quando se muda de sabor. Marcar de novo nao custa nada; deixar
  // de marcar deixava o seletor de sabor a aparecer outra vez.
  const observer = new MutationObserver(() => pzMarcarBundles());
  observer.observe(document.body, { childList: true, subtree: true });

  // Um produto sem bundles nunca traz o widget, e deixar um observador a olhar
  // para a arvore toda para sempre custa. Vinte segundos cobrem qualquer
  // carregamento razoavel.
  setTimeout(() => observer.disconnect(), 20000);
}

document.addEventListener('DOMContentLoaded', setupProfizicBundles);
document.addEventListener('shopify:section:load', setupProfizicBundles);
